/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createManualBankLinking} from '../api'

export const useMutationCreateManualBankLinking = createReactQueryMutationHook('createManualBankLinking', createManualBankLinking)
